export default "__VITE_ASSET__d80cff8e__"